var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedMemberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 28.6C27.8569 28.6 31.2976 29.3833 33.7368 30.6029C36.2353 31.8523 37.3999 33.3938 37.3999 34.8002V37.3998H10.6001V34.8002C10.6001 33.3938 11.7653 31.8523 14.2642 30.6029C16.7034 29.3833 20.144 28.6 24.0005 28.6ZM24.0005 10.6C25.6447 10.6001 27.2216 11.2537 28.3843 12.4164C29.5468 13.5791 30.1997 15.156 30.1997 16.8002C30.1997 18.4444 29.5469 20.0213 28.3843 21.184C27.2216 22.3466 25.6447 23.0003 24.0005 23.0004C22.3561 23.0004 20.7784 22.3467 19.6157 21.184C18.4532 20.0213 17.8003 18.4444 17.8003 16.8002C17.8003 15.156 18.4532 13.5791 19.6157 12.4164C20.7784 11.2537 22.3561 10.6 24.0005 10.6Z",
    stroke: "#0B4F9F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedMemberIcon);
export default __webpack_public_path__ + "static/media/completed-member-icon.c6ec004e3ca61353c314904bba6d2070.svg";
export { ForwardRef as ReactComponent };